var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceivableFinancing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 60.5C1 27.9152 27.4152 1.5 60 1.5V1.5C92.5848 1.5 119 27.9152 119 60.5V60.5C119 93.0848 92.5848 119.5 60 119.5V119.5C27.4152 119.5 1 93.0848 1 60.5V60.5Z",
    fill: "#F4F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M29.5 98.5C44.1355 98.5 56 86.6355 56 72C56 57.3645 44.1355 45.5 29.5 45.5C14.8645 45.5 3 57.3645 3 72C3 86.6355 14.8645 98.5 29.5 98.5Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M94 98.5C108.359 98.5 120 86.6355 120 72C120 57.3645 108.359 45.5 94 45.5C79.6406 45.5 68 57.3645 68 72C68 86.6355 79.6406 98.5 94 98.5Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 68.2712C13 68.2712 15.6579 54.5 22.3632 54.5C29.0684 54.5 32.6358 76.1446 16.3224 78.5L13 68.2712Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13 68.2712C13 68.2712 15.6579 54.5 22.3632 54.5C29.0684 54.5 32.6358 76.1446 16.3224 78.5L13 68.2712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 29.5H19V79.5H48V29.5Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 33.5H21V71.5H45V33.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 60.5H26V65.5H39V60.5Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.7389 59.5C27.7389 59.5 30.9503 61.3063 29.7187 63.9822C28.487 66.658 24.7239 68.2876 24.6673 71.8047C24.6106 75.3218 24.6673 79.5 24.6673 79.5H19V71.3204L27.7389 59.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0049 63.6025C18.0049 63.6025 24.0185 58.037 26.6158 58.5311C28.7608 58.9404 28.7647 62.8014 24.0926 66.0129C23.145 66.6585 22.3616 67.4806 21.7951 68.4237C21.2286 69.3668 20.8923 70.4089 20.8089 71.4796C20.6764 73.276 20.029 75.4111 18.0049 77.0275C13.7697 80.4261 10.6264 77.4792 11.0359 72.8913C11.4454 68.3034 11.7184 66.9446 18.0049 63.6025Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 76.8018L18.8294 106.5L1 103.12L9.96345 73.5L21 76.8018Z",
    fill: "#0070AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11 105.194L15.2324 75.5L21 77.063L18.6232 106.5L11 105.194Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 32.5C27.5523 32.5 28 32.0523 28 31.5C28 30.9477 27.5523 30.5 27 30.5C26.4477 30.5 26 30.9477 26 31.5C26 32.0523 26.4477 32.5 27 32.5Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 78.5C34.6569 78.5 36 77.1569 36 75.5C36 73.8431 34.6569 72.5 33 72.5C31.3431 72.5 30 73.8431 30 75.5C30 77.1569 31.3431 78.5 33 78.5Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.927 65.3895C110.927 65.3895 112.218 48.9507 103.938 47.5584C95.6584 46.1661 94.6272 70.1242 101.719 70.483C108.811 70.8418 110.927 65.3895 110.927 65.3895Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101 70.4837C108.646 70.8278 110.921 65.5993 110.921 65.5993C110.921 65.5993 112.312 49.8352 103.391 48.5",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7896 70.5H104.999V45.6649C105.019 45.1121 104.818 44.5739 104.441 44.1681C104.064 43.7624 103.542 43.5221 102.988 43.5H73.7896C72.2398 43.5 71 44.8454 71 46.5077V67.4923C71 69.1546 72.2476 70.5 73.7896 70.5Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9772 62.2187L89.4782 60.1725L85.7968 32.2849L70.2959 34.3311L73.9772 62.2187Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M75.0973 60.5581L87.9685 58.859L84.6797 33.9451L71.8085 35.6441L75.0973 60.5581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.976 57.4338L97.477 55.3876L93.7956 27.5L78.2947 29.5462L81.976 57.4338Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M83.0937 55.7774L95.9649 54.0783L92.6761 29.1644L79.8049 30.8635L83.0937 55.7774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3014 59.139L100.767 61.4366L104.901 33.6124L89.4349 31.3148L85.3014 59.139Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M86.8316 57.8501L99.6735 59.7579L103.366 34.9006L90.5243 32.9928L86.8316 57.8501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 45.5V71.5H77.6545C76.8819 71.4916 76.1241 71.296 75.4526 70.9316C74.781 70.5671 74.2176 70.0458 73.8155 69.4167C73.2792 68.609 72.9963 67.6719 73.0001 66.7159V50.2952C72.9962 49.4946 73.1943 48.7049 73.5775 47.9925C73.9484 47.2587 74.5262 46.6379 75.2464 46.1996C75.9665 45.7614 76.8003 45.523 77.6545 45.5112L105 45.5Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2044 61.5H71V56.5H81.2044C81.9459 56.5 82.6569 56.7632 83.1812 57.2317C83.7055 57.7003 84 58.3357 84 58.9983V58.9983C84.0005 59.3267 83.9286 59.6519 83.7883 59.9554C83.648 60.2589 83.4422 60.5347 83.1825 60.7671C82.9229 60.9994 82.6146 61.1837 82.2751 61.3095C81.9357 61.4353 81.5719 61.5 81.2044 61.5V61.5Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 60.5C81.3284 60.5 82 59.6046 82 58.5C82 57.3954 81.3284 56.5 80.5 56.5C79.6716 56.5 79 57.3954 79 58.5C79 59.6046 79.6716 60.5 80.5 60.5Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.994 69.5038C102.994 70.1846 102.978 70.8548 102.962 71.5H97C97.1185 70.8207 97.2843 70.1532 97.4958 69.5038C97.6955 68.8815 97.9511 68.2843 98.2583 67.7214C98.7604 66.816 99.7583 62.8093 99.115 59.5226C99.0627 59.2349 98.9935 58.9515 98.9079 58.6743C98.8501 58.4844 98.8039 58.2903 98.7698 58.0932C98.6579 57.6304 98.6571 57.1421 98.7674 56.6788C98.8778 56.2156 99.0953 55.7944 99.3974 55.4589C99.7176 55.1092 100.096 54.8364 100.511 54.6568C100.647 54.5922 100.786 54.5397 100.929 54.5C102.721 55.8332 103.053 63.1871 102.994 69.5038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.715 61.3145C108.715 61.3145 106.414 53.318 103.861 52.5695C101.756 51.9489 99.6815 55.5485 102.061 60.724C102.55 61.7685 102.799 62.9016 102.791 64.0464C102.783 65.1912 102.518 66.3209 102.014 67.3589C101.168 69.0966 100.595 71.3948 101.501 73.8396C103.406 78.985 108.621 78.4133 110.723 73.9487C112.824 69.484 112.452 67.3514 108.715 61.3145Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 74.8019L102.171 104.5L120 101.12L111.037 71.5L100 74.8019Z",
    fill: "#0070AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110 103.148L105.768 72.5L100 74.1134L102.377 104.5L110 103.148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 49.377C50 49.377 57.4216 45.0729 67 49.5",
    stroke: "#A8A8A8",
    strokeWidth: 2.03,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.01 5.07"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M32.9011 55.3481C37.1702 55.3481 40.6311 51.8872 40.6311 47.618C40.6311 43.3489 37.1702 39.888 32.9011 39.888C28.6319 39.888 25.171 43.3489 25.171 47.618C25.171 51.8872 28.6319 55.3481 32.9011 55.3481Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33 55.5C37.4183 55.5 41 51.9183 41 47.5C41 43.0817 37.4183 39.5 33 39.5C28.5817 39.5 25 43.0817 25 47.5C25 51.9183 28.5817 55.5 33 55.5Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7721 43.5C33.994 43.5 34.0617 43.5886 34.0617 43.8335V44.3612C34.4488 44.4074 34.8175 44.5709 35.1282 44.8341C35.4389 45.0973 35.68 45.4504 35.8258 45.8555C35.9386 46.113 35.8935 46.2777 35.634 46.3832L35.1638 46.6196C34.9419 46.7378 34.8366 46.6829 34.7124 46.4254C34.6163 46.1553 34.445 45.9272 34.2241 45.7751C34.0032 45.6229 33.7444 45.5549 33.4862 45.5811C32.67 45.5811 32.2977 45.8513 32.2977 46.4634C32.317 46.6509 32.3934 46.8252 32.5141 46.9567C32.6347 47.0883 32.7921 47.169 32.9597 47.1853C33.1867 47.2404 33.4166 47.2799 33.648 47.3035C34.0827 47.3277 34.5121 47.4215 34.9231 47.5821C35.1302 47.6561 35.3229 47.7736 35.491 47.9282C35.6606 48.1282 35.7928 48.3641 35.88 48.6222C35.9672 48.8802 36.0076 49.1552 35.9988 49.431C35.9988 50.6046 35.2992 51.4024 34.0617 51.6051V52.1665C34.0617 52.4114 33.994 52.5 33.7721 52.5H33.2455C33.0274 52.5 32.9484 52.4114 32.9484 52.1665V51.6177C32.5184 51.5848 32.1067 51.4097 31.7653 51.1144C31.4239 50.8191 31.1681 50.417 31.0301 49.9587C31.0097 49.9105 30.9994 49.8577 31 49.8044C31.0006 49.751 31.012 49.6985 31.0334 49.6509C31.0548 49.6032 31.0857 49.5617 31.1235 49.5295C31.1614 49.4972 31.2054 49.4751 31.252 49.4648L31.7222 49.2706C31.9629 49.1735 32.0682 49.2411 32.1735 49.507C32.2701 49.7968 32.4494 50.0425 32.6835 50.2059C32.9175 50.3693 33.1932 50.4412 33.4674 50.4104C34.3476 50.4104 34.7877 50.098 34.7877 49.4648C34.7954 49.3183 34.7592 49.173 34.6849 49.0522C34.6106 48.9313 34.5025 48.8418 34.3777 48.7978C34.0724 48.6779 33.753 48.6096 33.4298 48.5952C32.9892 48.5666 32.5552 48.4612 32.1435 48.2828C31.9412 48.2012 31.7529 48.0813 31.5868 47.9282C31.4158 47.7369 31.2818 47.5081 31.1931 47.2561C31.1045 47.0041 31.0631 46.7342 31.0715 46.4634C31.0715 45.3025 31.7222 44.5258 32.9521 44.3527V43.8335C32.9521 43.5886 33.0311 43.5 33.2493 43.5H33.7721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1022 48.5L68 49.8779L65 50.5",
    stroke: "#A8A8A8",
    strokeWidth: 2.03,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.01 5.07"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_159)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 32,
    r: 7.5,
    fill: "#003353"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.5196 28.6764C44.7001 28.6764 43.9439 28.9463 43.334 29.4025V27.8844H41.8595V32.0032H43.3609C43.5252 30.956 44.4289 30.155 45.5196 30.155C46.7266 30.155 47.7051 31.1361 47.7051 32.3464C47.7051 33.4215 46.9331 34.316 45.9145 34.5019V35.9952C47.7499 35.7977 49.1797 34.2395 49.1797 32.3464C49.1797 30.3197 47.5408 28.6764 45.5196 28.6764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3707 32.7306H41.8843C42.0687 34.4622 43.4474 35.8344 45.1745 35.9953V34.5029C44.261 34.3585 43.5357 33.6429 43.3707 32.7306Z",
    fill: "#00A0F3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 118.5C27.9675 118.5 2 92.5325 2 60.5H0C0 93.6371 26.8629 120.5 60 120.5V118.5ZM118 60.5C118 92.5325 92.0325 118.5 60 118.5V120.5C93.1371 120.5 120 93.6371 120 60.5H118ZM60 2.5C92.0325 2.5 118 28.4675 118 60.5H120C120 27.3629 93.1371 0.5 60 0.5V2.5ZM60 0.5C26.8629 0.5 0 27.3629 0 60.5H2C2 28.4675 27.9675 2.5 60 2.5V0.5Z",
    fill: "#E6F2FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_159",
    x: 26,
    y: 13.5,
    width: 39,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0820513 0 0 0 0 0.16 0 0 0 0 0.32 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_159"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_159",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 60.5C1 27.9152 27.4152 1.5 60 1.5V1.5C92.5848 1.5 119 27.9152 119 60.5V60.5C119 93.0848 92.5848 119.5 60 119.5V119.5C27.4152 119.5 1 93.0848 1 60.5V60.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivableFinancing);
export default __webpack_public_path__ + "static/media/ReceivableFinancing.10353500f21614c18bca014b2eae2bdd.svg";
export { ForwardRef as ReactComponent };